// @spec SHL-STR-045
import { useMediaQuery } from './use-media-query';

/**
 * Convenience hook for detecting mobile viewports.
 *
 * Uses the standard 768px breakpoint (matching Tailwind's `md` breakpoint).
 * Returns `true` for viewports < 768px (mobile), `false` for >= 768px (tablet/desktop).
 * Returns `false` on server for SSR hydration safety.
 *
 * @returns Whether the current viewport is mobile-sized
 *
 * @example
 * function ResponsiveComponent() {
 *   const isMobile = useIsMobile();
 *
 *   return isMobile ? <MobileView /> : <DesktopView />;
 * }
 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)');
}
